import {
    apiRequest,
    acsosiokulturalLevel,
    acsosiokulturalDetail
} from "../../../../../services/adapters/kepegawaian/Accompetence"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", acsosiokulturalDetail, {
            params: query
        }, true)
    }

    fetchLevel = async (query) => {
        return await apiRequest("get", acsosiokulturalLevel, {
            params: query
        }, true)
    }
}

export default DetailRepository